<div class="ui-g common-page-top">
  <div class="ui-g-12 ui-md-12">
    <h4>Update User Password</h4>
  </div>
</div>

<form [formGroup]="passwordForm">
  <div class="ui-fluid">
    <div class="ui-md-12">
      <p-panel class="width-100">
        <p-header>
          Change Password
        </p-header>
        <div class="ui-fluid">
          <div class="ui-g form-group">
            <div class="ui-g-12 ui-md-2">
              <label class="fw-700" for="oldPassword">Old Password</label>
            </div>
            <div class="ui-g-12 ui-md-4">
              <span class="md-inputfield">
                <div class="pwd-input-group">
                  <input type="text" pInputText [(ngModel)]="oldPassword" formControlName="oldPassword"
                    [class.password-mask]="isPasswordMasked" />
                  <button pButton type="button" icon="pi pi-eye" (click)="togglePasswordMask()"
                    class="transparent-button"></button>
                </div>
                <!-- <input id="oldPassword" pInputText type="password" formControlName="oldPassword"
                  [(ngModel)]="oldPassword" name="oldPassword" class="ui-inputtext" autocomplete="off"
                  autocomplete="off"> -->

              </span>
            </div>

            <div class="ui-g-12 ui-md-2">
              <label class="fw-700" for="newPassword">New Password</label>
            </div>
            <div class="ui-g-12 ui-md-4">
              <div class="pwd-input-group">
                <input type="text" pInputText [(ngModel)]="newPassword" formControlName="newPassword"
                  pTooltip={{validationMessageForTT}} tooltipEvent="focus" [tooltipOptions]="{ escape: false }"
                  (keyup)="validatePassword($event)" [class.password-mask]="isPasswordMasked" />
                <button pButton type="button" icon="pi pi-eye" (click)="togglePasswordMask()"
                  class="transparent-button"></button>
              </div>
              <!-- <div class="pwd-input-group">
                <input type="text" pInputText [(ngModel)]="newPassword" formControlName="newPassword"
                  pTooltip={{validationMessageForTT}} tooltipEvent="focus" (keyup)="validatePassword($event)"
                  [class.password-mask]="isPasswordMasked" />
                <button pButton type="button" icon="pi pi-eye" (click)="togglePasswordMask()"
                  class="transparent-button"></button>
              </div> -->

            </div>

            <div class="ui-g-12 ui-md-2">
              <label class="fw-700" for="confirmPassword">Confirm New Password</label>
            </div>
            <div class="ui-g-12 ui-md-4">
              <div class="pwd-input-group">
                <input type="text" pInputText [(ngModel)]="confirmPassword" formControlName="confirmPassword"
                  [class.password-mask]="isPasswordMasked" />
                <button pButton type="button" icon="pi pi-eye" (click)="togglePasswordMask()"
                  class="transparent-button"></button>

              </div>
              <p-message severity="error" text="Password Mismatch" *ngIf="
                              !passwordForm.hasError('required') &&
                              passwordForm.hasError('mismatch') &&
                              passwordForm.controls['confirmPassword'].dirty
    
    
                            "></p-message>
              <!-- <span class="md-inputfield">
                <input id="confirmPassword" pInputText type="password" formControlName="confirmPassword"
                  [(ngModel)]="confirmPassword" name="confirmPassword" class="ui-inputtext" autocomplete="off">

                <p-message severity="error" text="Password Mismatch" *ngIf="
                              !passwordForm.hasError('required') &&
                              passwordForm.hasError('mismatch') &&
                              passwordForm.controls['confirmPassword'].dirty
    
    
                            "></p-message>
              </span> -->
            </div>
          </div>
        </div>
      </p-panel>
    </div>
  </div>

  <div class="ui-g ui-g-12 mt-2">
    <button type="submit" pButton icon="fa fa-pencil-square-o" class="ui-button-info mr-1"
      (click)="onUpdatePassSubmit(client)" [disabled]="!passwordForm.valid" label="Update"></button>
    <button type="button" pButton icon="fa fa-close" class="ui-button-info" (click)="goBack()" label="Cancel"></button>
  </div>

</form>


<!-- <form [formGroup]="passwordForm" *ngIf="!isUserFrom">
          <div class="ui-g ui-g-12">
            <p-panel class="width-100">
              <p-header>
              Change Password
              </p-header>
              <div class="ui-fluid">
                    <div class="ui-g form-group">
                      <div class="ui-g-12 ui-md-2">
                          <label class="fw-700" for="oldPassword">Old Password</label>
                        </div>
                      <div class="ui-g-12 ui-md-4">
                          <span class="md-inputfield">
                            <input id="oldPassword" pInputText type="password" formControlName="oldPassword" [(ngModel)]="oldPassword" name="oldPassword" class="ui-inputtext"  autocomplete="off"
                              autocomplete="off">
                              <label>Old Password</label>
                           
                          </span>
                        </div>
        
                        <div class="ui-g-12 ui-md-2">
                            <label class="fw-700" for="newPassword">New Password</label>
                          </div>
                        <div class="ui-g-12 ui-md-4">
                            <span class="md-inputfield">
                              <input id="newPassword" pInputText type="password" formControlName="newPassword" [(ngModel)]="newPassword" name="newPassword" class="ui-inputtext"
                                autocomplete="off">
                                <label>New Password</label>
                             
                            </span>
                          </div>
        
                          <div class="ui-g-12 ui-md-2">
                              <label class="fw-700" for="confirmPassword">Confirm New Password</label>
                            </div>
                          <div class="ui-g-12 ui-md-4">
                              <span class="md-inputfield">
                                <input id="confirmPassword" pInputText type="password" formControlName="confirmPassword" [(ngModel)]="confirmPassword" name="confirmPassword" class="ui-inputtext"
                                  autocomplete="off">
                                  <label>Confirm New Password</label>
                                 <p-message severity="error" text="Password Mismatch"  *ngIf="
                                 !passwordForm.hasError('required') &&
                                 passwordForm.hasError('mismatch') &&
                                 passwordForm.controls['confirmPassword'].dirty
        
        
                               "></p-message>
                              </span>
                            </div>
                    </div>
              </div>
            </p-panel>
          </div>
        
            <div class="ui-g ui-g-12">
              <button type="submit" pButton icon="fa fa-pencil-square-o" class="ui-button-info mr-5" (click)="onUpdatePassSubmit(client)" [disabled]="!passwordForm.valid" label="{{buttonText}}"></button>
              <button type="button" pButton icon="fa fa-close" class="ui-button-info" (click)="goBack()" label="{{'COMMON-BUTTON.CANCEL' | translate}}"></button>
            </div>
        
          </form> -->